import AuthApi from '../../api/auth';
import vueAuth from '../../services/vueAuth';
import AuthService from '../../services/vueAuth';
import EventBus from "../../bus/events";
import {APP_CONFIG} from "../../config";
import {router} from '../../router';

export const auth = {
    state: {
        isAuthenticated: false,
        accessToken: null,
        validationErrors: {},
        authenticatedUser: {},
        userPermissions: []
    },

    // You can use it as a state getter function (probably the best solution)
    getters: {
        isAuthenticated(state) {
            return state.isAuthenticated;
        },

        getValidationErrors(state) {
            return state.validationErrors;
        },

        getAccessToken(state) {
            return state.accessToken;
        },

        getAuthenticatedUser(state) {
            return state.authenticatedUser;
        },

        user(state) {
            return state.authenticatedUser;
        }
    },

    // Mutation for when you use it as state property
    mutations: {
        isAuthenticated(state, payload) {
            state.isAuthenticated = payload.state
        },

        setValidationErrors(state, payload) {
            state.validationErrors = payload.errors;
        },

        setAccessToken(state, token) {
            state.accessToken = token;
        },

        setAuthenticatedUser(state, payload) {
            state.authenticatedUser = payload.user;
        }
    },

    actions: {

        // Perform VueAuthenticate login using Vuex actions
        USER_LOGIN(context, payload) {
            context.commit('setValidationErrors', {errors: {}});
            return AuthApi.attemptLogin(payload).then(({data}) => {
                context.dispatch('setTokens', data);
                context.commit('isAuthenticated', {state: true});
                context.commit('setValidationErrors', {errors: {}});
                EventBus.$emit('user-authenticated');
                context.commit('setLoadingStatus', false);
            }).catch((error) => {
                context.commit('setLoadingStatus', false);
                if(error.response !== 'undefined' && error.response.status === 422) {
                    context.commit('setValidationErrors', error.response.data);
                } else {
                    throw new Error('Login failed')
                }
            });
        },

        logOut(context, payload) {
            AuthApi.logOut(payload).then(() => {
                AuthService.removeToken();
                context.commit('setAccessToken', false);
                context.commit('isAuthenticated', {state: false});
                // Fire Log out event
                EventBus.$emit('user-logged-out', payload.user);
            })
        },
        /**
         *  Set authenticated user from token
         *
         * @param context
         */
        setUserFromToken(context) {
            axios.get(APP_CONFIG.URL + 'user/profile?include=permissions,roles')
                .then((response) => {
                    context.commit('setAuthenticatedUser', {user: response.data.data});
                    EventBus.$emit('user-profile-set', response.data.data);
                }).catch(() => {
                vueAuth.removeToken();
                router.push('/login');
            });
        },
        /*
            Save access and refresh tokens to the local storage
         */
        setTokens(context, token) {
            AuthService.setToken(token);
            context.commit('setAccessToken', token.access_token);
        },

        /**
         * get access tokens from local storage
         *
         * @param context
         */
        getToken(context) {
            let token = AuthService.getToken();
            if (token) {
                context.commit('setAccessToken', token.accessToken);
                context.commit('isAuthenticated', {
                    state: true
                });
            }
        }
    }
};
